import { Column } from '@tanstack/react-table';
import i18next from 'i18next';

import { MenuItem, MenuSection } from '@work4all/components';

const getLabel = (column: Column<unknown> & { title?: string }) => {
  return typeof column.columnDef.header === 'string'
    ? column.columnDef.header
    : typeof column.title === 'string'
    ? column.title
    : typeof column.columnDef.title === 'string'
    ? column.columnDef.title
    : column.id;
};

const getPath = (column: Column<unknown>) => {
  if (
    !(column.columnDef as any).filterSubgroupPath ||
    (column.columnDef as any).filterSubgroupPath.length === 0
  ) {
    return 'itemsWithoutPath';
  }

  if ((column.columnDef as any).filterSubgroupPath[0] === 'MASK.INDIVIDUAL') {
    return 'individualItems';
  }

  const path = (column.columnDef as any).filterSubgroupPath.join('');

  if (path === '') {
    return 'itemsWithoutPath';
  }

  return path;
};

const columnsToMenuItem = (column: Column<unknown>) => {
  return {
    ...column,
    id: column.id,
    label: getLabel(column),
  };
};

const sortItemsByLabel = (
  items: MenuItem<Column<unknown>>[]
): MenuItem<Column<unknown>>[] => {
  return items.sort((a, b) => {
    return (a.label ?? 0) > (b.label ?? 0)
      ? 1
      : (a.label ?? 0) === (b.label ?? 0)
      ? 0
      : -1;
  });
};

export const columnsToMenuSectionsV8 = (
  columns: Column<unknown>[]
): MenuSection<Column<unknown>>[] => {
  const organizedItems: Record<string, MenuItem<Column<unknown>>[]> =
    columns.reduce(
      (obj, column) => {
        const path = getPath(column);
        const item = columnsToMenuItem(column);
        const pathValue = obj[path] ?? [];

        return { ...obj, [path]: [...pathValue, item] };
      },
      { itemsWithoutPath: [], individualItems: [] }
    );

  const { itemsWithoutPath, individualItems, ...rest } = organizedItems;

  const other: MenuItem<Column<unknown>>[] = Object.keys(rest).map((key) => {
    return {
      id: key,
      label: i18next.t(key),
      sections: [{ items: sortItemsByLabel(rest[key]) }],
    };
  });

  const sections: MenuSection<Column<unknown>>[] = [];

  if (itemsWithoutPath.length > 0) {
    sections.push({ items: sortItemsByLabel(itemsWithoutPath) });
  }

  if (individualItems.length > 0 && other.length > 0) {
    sections.push({
      items: [
        ...sortItemsByLabel(other),
        {
          id: 'MASK.INDIVIDUAL',
          label: i18next.t('MASK.INDIVIDUAL'),
          sections: [{ items: sortItemsByLabel(individualItems) }],
        },
      ],
    });
  } else if (individualItems.length > 0) {
    sections.push({
      items: [
        {
          id: 'MASK.INDIVIDUAL',
          label: i18next.t('MASK.INDIVIDUAL'),
          sections: [{ items: sortItemsByLabel(individualItems) }],
        },
      ],
    });
  } else if (other.length > 0) {
    sections.push({ items: other });
  }

  return sections;
};
